// Actions
export const GET_NEXT_TAGS = 'GET_NEXT_TAGS'
export const GET_TAG_DATA_FROM_REFERENCE = 'GET_TAG_DATA_FROM_REFERENCE'
export const UPDATE_TAGS_DATES = 'UPDATE_TAGS_DATES'
export const MERGE_TAG = 'MERGE_TAG'
export const RESET_TAGS_ACTION = 'RESET_TAGS_ACTION'

// Mutations
export const UPDATE_TAGS_PUBLISHED_AT = 'UPDATE_TAGS_PUBLISHED_AT'
export const REFRESH_TAGS_PUBLISHED_AT = 'REFRESH_TAGS_PUBLISHED_AT'
export const ADD_TAG_REF = 'ADD_TAG_REF'
export const UPDATE_TAG_REF = 'UPDATE_TAG_REF'
export const SET_TAG_DATA = 'SET_TAG_DATA'
export const MERGE_TAG_DATA = 'MERGE_TAG_DATA'
export const DELETE_TAG = 'DELETE_TAG'
export const RESET_TAGS = 'RESET_TAGS'
export const MERGE_TAG_POST_DATA = 'MERGE_TAG_POST_DATA'



// WEBPACK FOOTER //
// ./src/store/actions/tagsQueries.js